let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
let POS = require("../../POS.js");
let QueueResourceModel = require("../../model/settings/QueueResourceModel.js");
let i18n = require("../../utils/i18n");

let main = function (Backbone, _, POS, QueueResourceModel, i18n) {
    return Backbone.View.extend({
        events: {
            "click .booking" : "onSelectItem",
            "click .save" : "saveResource",
            "click .delete" : "deleteResource",
            "click .createNew" : "createResource",
            "click .navbar-btn": "listResource"
        },

        initialize: function() {
            if(!this.model) {
                this.model = new QueueResourceModel();
            }
        },

        render: function(evt) {
            this.$("form").removeClass("hidden");
            if(this.model.get('id')) {
                this.renderEditWindow(evt);
            } else {
                this.renderCreateWindow();
            }
            return this;
        },

        renderEditWindow: function(evt) {
            this.$('#inputName').val(this.model.get("name"));
            this.$('#inputPrefix').val(this.model.get("prefix"));
        },

        renderCreateWindow: function() {
            this.$('fieldset').attr('disabled', null);
            this.$('#inputName, #inputPrefix').val("");
            this.$('.del').addClass('hidden');
            this.$('.delete').addClass('hidden');
        },

        onSelectItem: function(evt) {
            var booking = $(evt.currentTarget);
            this.model.set({id: booking.data('id'), name: booking.attr('data-name'), prefix: booking.attr('data-prefix')});
            var modal = this.$('.queueCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.settings.booking.title.edit.resource"));
            if(modal.find('.save').hasClass("saveCreate-btn")){
                modal.find('.save').removeClass('saveCreate-btn');
            }
            if(!modal.find('.save').hasClass("saveEdit-btn")){
                modal.find('.save').addClass('saveEdit-btn');
            }
            modal.modal('show');
            this.$('.del').removeClass('hidden');
            this.$('.delete').removeClass('hidden');
            this.render(evt);
        },

        createResource: function() {
            this.model.set({id: null, name: null, prefix: null});
            var modal = this.$('.queueCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.settings.booking.title.add.resource"));
            if(modal.find('.save').hasClass("saveEdit-btn")){
                modal.find('.save').removeClass('saveEdit-btn');
            }
            if(!modal.find('.save').hasClass("saveCreate-btn")){
                modal.find('.save').addClass('saveCreate-btn');
            }
            this.$('.modal.queueCreateModal').modal('show');
            this.render();
        },


        saveResource: function() {
            this.$('.form-group').removeClass('has-error').find('.help-block').text("");

            var params = {name: this.$('#inputName').val(), prefix: this.$('#inputPrefix').val(), organizationId: POS.get('rId')},
                result = $.post('/queue/saveResource' + (this.model.get("id")?"/" + this.model.get("id"):""), params), self = this;

            var validated = true;
            if(this.$('#inputName').val().trim()=="") {
                this.$('.form-group.name').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                validated = false;
            }
            if(this.$('#inputPrefix').val().trim()=="") {
                this.$('.form-group.prefix').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                validated = false;
            }

            if(!validated) {
                return;
            }

            result.done(function(res) {
                if(res.success) {
                    self.$("form").addClass("hidden");
                    self.$('.modal').modal('hide');
                    self.listResource();
                } else {
                    if(res.errors) {
                        alert(res.errors);
                        return;
                    }
                }
            });

            result.fail(function(res) {
                alert(res);
            });

            return false;
        },

        deleteResource: function() {
            var selectedResource = this.$('.booking.selected'), staffId = selectedResource.data('id'),
                result = null, self = this;

            if(!window.confirm(i18n.msg('pos.settings.confirmDelete', [this.model.get('name')]))) {
                return false;
            }

            result = $.post('/queue/deleteResource', {id: this.model.get("id")});

            result.done(function(res) {
                if(res.success) {
                    selectedResource.remove();
                    self.$("form").addClass("hidden");
                    self.$('.modal').modal('hide');
                    self.listResource();
                } else {
                    alert(i18n.msg('pos.setting.user.delete.failed'));
                }
            });

            result.fail(function(res) {
                alert(i18n.msg('pos.setting.user.delete.failed'));
            });

            return false;
        },

        showError: function(errors) {
            if(errors.email) {
                this.$('.form-group.email').addClass('has-error').
                    find('.help-block.error').removeClass('hidden').text(errors.email);
            }

            if(errors.phone) {
                this.$('.form-group.phone').addClass('has-error').
                    find('.help-block').text(errors.phone);
            }
        },

        listResource: function(e){
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            var rest = POS.getRestaurant(), result = $.post('/pos/queueResourceList', {
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.main').empty().append(res);
            });
        }
    });
};

let exportedValue = main(Backbone, _, POS, QueueResourceModel, i18n);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/QueueResourceSettingView.js